import { ref } from 'vue'

export const chunkErrorDetected = ref(false)

/**
 * True for the "stale tab after a new deploy" class of error: a content-hashed
 * chunk from a previous build no longer exists on the CDN. Shared by the
 * window-level listeners (main.js), router.onError, and any defineAsyncComponent
 * loader that needs to recover the same way instead of crashing to Sentry.
 */
export function isChunkLoadError(error: unknown): boolean {
  const err = error as { type?: string; message?: string; reason?: { message?: string } }
  const message = err?.message || err?.reason?.message || ''

  return (
    err?.type === 'vite:preloadError' ||
    message.includes('Importing a module script failed') ||
    message.includes('Failed to fetch dynamically imported module') ||
    // vue-router wraps a failed async route component load (same stale-chunk
    // cause) in its own message instead of surfacing the original fetch error.
    message.includes("Couldn't resolve component")
  )
}
